import { TEST_RECIPIENTS_VERSION } from './compose-panel.constants';

// The raw text last used in the test-send dialog's recipient fields, persisted
// per company+user so reopening prefills the addresses the admin sent to last.
export interface ITestRecipients {
  emails: string;
  phones: string;
}

interface ITestRecipientsEnvelope extends ITestRecipients {
  v: number;
}

// Same company+user namespacing as draftsStorageKey — "per client" plus
// shared-device isolation (one tablet, two coaches don't share a test inbox).
export const testRecipientsStorageKey = (companyId: string | undefined, userId: string | undefined) =>
  `mea:adHocCommTestRecipients:${companyId || 'none'}:${userId || 'anon'}`;

// Returns empty strings on a missing/corrupt/version-mismatched store.
export const loadTestRecipients = (storageKey: string): ITestRecipients => {
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) return { emails: '', phones: '' };
    const parsed = JSON.parse(raw) as ITestRecipientsEnvelope;
    if (!parsed || parsed.v !== TEST_RECIPIENTS_VERSION) return { emails: '', phones: '' };
    return {
      emails: typeof parsed.emails === 'string' ? parsed.emails : '',
      phones: typeof parsed.phones === 'string' ? parsed.phones : ''
    };
  } catch {
    return { emails: '', phones: '' };
  }
};

export const saveTestRecipients = (storageKey: string, recipients: ITestRecipients): void => {
  try {
    const envelope: ITestRecipientsEnvelope = { v: TEST_RECIPIENTS_VERSION, ...recipients };
    window.localStorage.setItem(storageKey, JSON.stringify(envelope));
  } catch {
    // Storage quota / private mode — non-fatal; the test send already succeeded.
  }
};
